import {store} from '@/store';

export default async function guest ({ next  }){
    return store.state.auth.authenticated ? next({name: 'Home'}) : next();
}
